import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContentBox({
  content,
  size = 'default',
  ordered = false,
}: {
  content: Props.ContentBox[];
  size?: 'default' | 'large';
  /** Render as a numbered sequence (<ol>) for step-by-step content. */
  ordered?: boolean;
}) {
  const { t } = useTranslation();
  const contentBox = `content-box content-box--${size} mt-md mb-md`;
  const contentBoxIcon = `content-box-item-icon content-box-item-icon--${size} mr-md`;

  return (
    <div className={contentBox}>
      {ordered ? (
        <ol className="content-box-wrapper content-box-steps">
          {content.map((item, index) => (
            <li className="content-box-item" key={item.key}>
              <span className="content-box-step" aria-hidden="true">
                {index + 1}
              </span>
              <div className={contentBoxIcon} aria-hidden="true">
                {item.icon}
              </div>
              <div className="content-box-item-text">{t(item.text)}</div>
            </li>
          ))}
        </ol>
      ) : (
        <div className="content-box-wrapper">
          {content.map(item => (
            <div className="content-box-item" key={item.key}>
              <div className={contentBoxIcon}>{item.icon}</div>
              {item.value ? (
                <>
                  <div className="content-box-item-text">
                    {item.value}
                    <br />
                    {t(item.text)}
                  </div>
                </>
              ) : (
                <div className="content-box-item-text">{t(item.text)}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
